import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { useEffect, useState } from "react";
import { DndProvider } from "react-dnd-multi-backend";
import { DraggableMessage } from "../components/Draggables";
import MayaBoxDestination from "../components/MayaBoxDestination";
import MayaBoxOrigin from "../components/MayaBoxOrigin";
import {
  COLOR_HIGHLIGHTED,
  FONT,
  MAYA_SYSTEM
} from "../defaults";
import { convertToAlternate, increaseProgress } from "../helpers";
import {
  buttonCheck,
  level1MayaNoneDropped,
  level1MayaTask1,
  level1MayaTask2,
  levelCorrect,
  levelIncorrect
} from "../strings";


const LevelNumber = 1;

function generateNumber(currentProgress) {
  const numbers = [8, 4, 13];
  if (currentProgress >= numbers.length) {
    return Math.round(Math.random() * 18) + 1; // Generate integer between 1 and 19.
  }
  return numbers[currentProgress];
}


function Level1Maya({levelProgress, setLevelProgress, showMessage, setShowMessage, disableInput, setDisableInput}) {
  const [number, setNumber] = useState(
    generateNumber(levelProgress[LevelNumber])
  );
  const [solution, setSolution] = useState([]);
  const [droppedItems, setDroppedItems] = useState([0, 0]); // How many items of each type have been dropped so far. [# of corn, # of baskets]
  const [message, setMessage] = useState("");
  const [correct, setCorrect] = useState(false);
  


  useEffect(() => {
    let newNumber = generateNumber(levelProgress[LevelNumber]);
    setNumber(newNumber);
    setDroppedItems([0, 0])
  }, [levelProgress]);

  useEffect(() => {
    let mayaArray = convertToAlternate(MAYA_SYSTEM, number);
    mayaArray.pop(); // Since convertToAlternate returns array of length 3, we don't use the last entry in this level.
    setSolution(mayaArray); // E.g. if solution is two corn plants and 1 basket, this is [2,1].
    setDroppedItems([0, 0]);
  }, [number]);

  /**
   * 
   * @param {*} item item[0] is index that corresponds to item type.
   * @param {String} whichBox Either "origin" or "destination". Defines which box an item was dropped into.
   */
  function handleDropItem(item, whichBox) {
    const index = item[0];
    const newDroppedItems = [...droppedItems];
    if (whichBox === "origin") { // Case: Item was moved back into origin box.
      newDroppedItems[index] -= 1;
    } 
    else if (whichBox === "destination") { // Case: Item was moved into destination box.
      newDroppedItems[index] += 1;
    }
    setDroppedItems(newDroppedItems);
  }

  const checkInput = () => {
    const isCorrect = (solution.toString() === droppedItems.toString());
    setCorrect(isCorrect);
    if (isCorrect) {
      setMessage(levelCorrect)
    } else if (droppedItems.toString() === "0,0") { // No items have been dropped.
      setMessage(level1MayaNoneDropped);
    } else {
      setMessage(levelIncorrect);
    }
    displayMessage();
  };

  const displayMessage = () => {
    setDisableInput(true);
    setShowMessage(true);
  };
 
  const handleCloseMessage = () => {
    if (correct) {
      increaseProgress(levelProgress, setLevelProgress, LevelNumber, MAYA_SYSTEM); // Triggers a useEffect.
    }
    setMessage("");
    setCorrect(false);
    setDisableInput(false);
  };

return (
    <div>
      <div
        className="Welcome-label"
        style={{ fontFamily: FONT, fontSize: "3.5dvh", marginTop: "4dvh" }}
      >
        {level1MayaTask1}
        <span style={{fontFamily: FONT, color: COLOR_HIGHLIGHTED, fontSize: "5dvh"}}>{number}</span>
        {level1MayaTask2}
      </div>
      
      <DndProvider options={HTML5toTouch}>
        {showMessage && <DraggableMessage show={showMessage} setShow={setShowMessage} handleClose={handleCloseMessage} message={message}/>} {/* Conditionally rendering it with showMessage makes the message re-render, and hence center itself, every time. */}
        <div style={{ display: "flex", flexDirection: "column"}}>
          <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: "4dvh", marginRight: "10dvh"}}>
            <div>
              <MayaBoxOrigin
                id={"origin"}
                onDropItem={handleDropItem}
                droppedItems={droppedItems}
                itemSize={7}
                />
            </div>
            <div style={{display: "flex", flexDirection: "row"}}>
              <MayaBoxDestination
                id={"destination"}
                onDropItem={handleDropItem}
                droppedItems={droppedItems}
                itemSize={7}
              />
            </div>
            <div style={{fontFamily: FONT, fontSize: "5dvh", textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",}}>
            &nbsp;&nbsp;&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;&nbsp;<span style={{color: COLOR_HIGHLIGHTED}}>{number}</span>
            </div>
          </div>
        </div>
        <button
          onClick={checkInput}
          className="checkAnswer-button"
          disabled={disableInput}
        >
          {buttonCheck}
        </button>
      </DndProvider>
    </div>
  );
}

export default Level1Maya;